<!doctype html>

<!-- 
  To change the theme, change the class on the html tag below to one of:
  - theme-auto: Automatically switches based on user's system preferences
  - theme-light: Forces light theme
  - theme-dark: Forces dark theme
-->

<html class="theme-auto" lang="en">
    <!-- Update`class="theme-auto" with your preference -->

    <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        <!-- Page Title - Change this to your name/brand (50-60 characters recommended) -->
        <title>Sunset's Landing Page</title>

        <!-- https://realfavicongenerator.net/ -->
        <link
            rel="icon"
            type="image/png"
            href="./favicon-96x96.png"
            sizes="96x96"
        />
        <link rel="icon" type="image/svg+xml" href="./favicon.svg" />
        <link rel="shortcut icon" href="./favicon.ico" />
        <link
            rel="apple-touch-icon"
            sizes="180x180"
            href="./apple-touch-icon.png"
        />
        <meta
            name="apple-mobile-web-app-title"
            content="Sunset's Landing Page"
        />
        <link rel="manifest" href="./site.webmanifest" />

        <!-- Meta Description - Write a description (150-160 characters recommended) -->
        <meta
            name="description"
            content="Hello! I'm Sunset Mikoto. Full-stack developer, Windows & Linux user, Gamer."
        />

        <!-- Keywords -->
        <meta
            name="keywords"
            content="Sunset, Homepage, Landing Page, Sunset Mikoto"
        />

        <!-- Canonical URL - Helps prevent duplicate content issues -->
        <meta rel="canonical" href="https://sunmkt.uk/" />

        <!-- Author Information -->
        <meta name="author" content="Sunset Mikoto" />

        <!-- Stylesheets -->
        <link rel="stylesheet" href="./css/reset.css" />
        <link rel="stylesheet" href="./css/style.css" />
        <link rel="stylesheet" href="./css/brands.css" />
        <link rel="stylesheet" href="./css/brands-extended.css" />
        <link rel="stylesheet" href="./css/custom.css" />
        <link
            rel="stylesheet"
            href="./css/HarmonyOSSansSCSplittedRegular.css"
        />
        <link rel="stylesheet" href="./css/HarmonyOSSansSCSplittedBold.css" />

        <!-- Stylesheets / Sensitive Content Module -->
        <link rel="stylesheet" href="./css/sensitive-content.css" />
    </head>

    <body>
        <div class="container">
            <div class="column">
                <!-- 
              By default, the Avatar is rounded. Use the following:
              - avatar--rounded: Automatically rounds the image
              - avatar--soft: Slightly rounds the image
              - avatar--none: Removes any rounding

              Be sure to replace the src with your own image path and update the alt text
            -->
                <picture>
                    <source
                        srcset="./images/avatar2_pride.webp"
                        type="image/webp"
                    />
                    <img
                        class="avatar avatar--rounded"
                        src="./images/avatar2_pride.png"
                        alt="Avatar"
                    />
                </picture>

                <!-- Replace with your name or brand -->
                <h1 tabindex="0">
                    <div>Sunset Mikoto</div>
                </h1>

                <!-- Add a short description about yourself or your brand -->
                <p tabindex="0">
                    Full-stack developer, Windows & Linux user, Gamer.
                </p>

                <!-- All your buttons go here -->
                <div class="button-stack" role="navigation">
                    <h2>Contact Me</h2>

                    <!-- GitHub -->
                    <a
                        class="button button-github"
                        href="https://github.com/SunsetMkt"
                        target="_blank"
                        rel="me"
                        role="button"
                        ><img
                            class="icon"
                            aria-hidden="true"
                            src="./images/icons/github.svg"
                            alt="GitHub Logo"
                        />GitHub</a
                    >

                    <!-- Generic Email -->
                    <a
                        class="button button-default"
                        href="mailto:hi@sunmkt.uk"
                        target="_blank"
                        rel="me"
                        role="button"
                        ><img
                            class="icon"
                            aria-hidden="true"
                            src="./images/icons/generic-email.svg"
                            alt="Email Icon"
                        />Email Me</a
                    >

                    <!-- Bluesky -->
                    <a
                        class="button button-bluesky"
                        href="https://bsky.app/profile/sunmkt.uk"
                        target="_blank"
                        rel="me"
                        role="button"
                        ><img
                            class="icon"
                            aria-hidden="true"
                            src="./images/icons/bluesky.svg"
                            alt="Bluesky Logo"
                        />Bluesky</a
                    >

                    <!-- Matrix -->
                    <a
                        class="button button-matrix-alt"
                        href="https://matrix.to/#/@sunmkt:mozilla.org"
                        target="_blank"
                        rel="me"
                        role="button"
                        ><img
                            class="icon"
                            aria-hidden="true"
                            src="./images/icons-extended/matrix-alt.svg"
                            alt="Matrix Logo"
                        />Matrix</a
                    >

                    <!-- Keybase -->
                    <a
                        class="button button-keybase"
                        href="https://keybase.io/sunsetmkt"
                        target="_blank"
                        rel="me"
                        role="button"
                        ><img
                            class="icon"
                            aria-hidden="true"
                            src="./images/icons-extended/keybase.svg"
                            alt="Keybase Logo"
                        />Keybase</a
                    >

                    <!-- Patreon -->
                    <a
                        class="button button-patreon"
                        href="https://donate.sunmkt.uk/"
                        target="_blank"
                        rel="me"
                        role="button"
                        ><img
                            class="icon"
                            aria-hidden="true"
                            src="./images/icons/patreon.svg"
                            alt="Patreon Logo"
                        />Patreon</a
                    >

                    <a
                        class="button button-default"
                        href="https://blog.sunmkt.uk/friends/"
                        target="_blank"
                        rel="noopener"
                        role="button"
                        ><img
                            class="icon fontawesome"
                            aria-hidden="true"
                            src="./images/icons-fa/heart_solid.svg"
                            alt="Heart Icon"
                        />Friends</a
                    >

                    <h2>My Services</h2>

                    <a
                        class="button button-default"
                        href="https://blog.sunmkt.uk/"
                        target="_blank"
                        rel="noopener"
                        role="button"
                        ><img
                            class="icon"
                            aria-hidden="true"
                            src="./images/icons/generic-blog.svg"
                            alt="Blog Icon"
                        />Blog</a
                    >

                    <a
                        class="button button-default"
                        href="https://status.sunmkt.uk/"
                        target="_blank"
                        rel="noopener"
                        role="button"
                        ><img
                            class="icon fontawesome"
                            aria-hidden="true"
                            src="./images/icons-fa/chart-bar_solid.svg"
                            alt="Website Icon"
                        />Site Status</a
                    >

                    <a
                        class="button button-default"
                        href="https://cookie.sunmkt.uk/"
                        target="_blank"
                        rel="noopener"
                        role="button"
                        ><img
                            class="icon fontawesome"
                            aria-hidden="true"
                            src="./images/icons-fa/cookie-bite_solid.svg"
                            alt="Website Icon"
                        />Cookie Clicker</a
                    >

                    <a
                        class="button button-default"
                        href="https://cyberchef.sunmkt.uk/"
                        target="_blank"
                        rel="noopener"
                        role="button"
                        ><img
                            class="icon fontawesome"
                            aria-hidden="true"
                            src="./images/icons-fa/chess-rook_solid.svg"
                            alt="Website Icon"
                        />CyberChef</a
                    >

                    <h2>Useful Links</h2>

                    <a
                        class="button button-default"
                        href="https://findahelpline.com/"
                        target="_blank"
                        rel="noopener"
                        role="button"
                        ><img
                            class="icon fontawesome"
                            aria-hidden="true"
                            src="./images/icons-fa/heart_solid.svg"
                            alt="Website Icon"
                        />Find A Helpline</a
                    >

                    <a
                        class="button button-default"
                        href="https://apps.disroot.org/"
                        target="_blank"
                        rel="noopener"
                        role="button"
                        ><img
                            class="icon fontawesome"
                            aria-hidden="true"
                            src="./images/icons-fa/magnifying-glass_solid.svg"
                            alt="Website Icon"
                        />SearXNG</a
                    >

                    <a
                        class="button button-default"
                        href="https://www.zaobao.com/"
                        target="_blank"
                        rel="noopener"
                        role="button"
                        ><img
                            class="icon fontawesome"
                            aria-hidden="true"
                            src="./images/icons-fa/newspaper_solid.svg"
                            alt="Website Icon"
                        />Lianhe Zaobao</a
                    >

                    <a
                        class="button button-default"
                        href="https://massgrave.dev/"
                        target="_blank"
                        rel="noopener"
                        role="button"
                        ><img
                            class="icon fontawesome"
                            aria-hidden="true"
                            src="./images/icons-fa/microsoft.svg"
                            alt="Website Icon"
                        />Microsoft Activation</a
                    >

                    <a
                        class="button button-default"
                        href="https://www.mozilla.org/firefox/"
                        target="_blank"
                        rel="noopener"
                        role="button"
                        ><img
                            class="icon fontawesome"
                            aria-hidden="true"
                            src="./images/icons-fa/firefox-browser.svg"
                            alt="Website Icon"
                        />Firefox</a
                    >

                    <a
                        class="button button-default"
                        href="https://speed.cloudflare.com/"
                        target="_blank"
                        rel="noopener"
                        role="button"
                        ><img
                            class="icon fontawesome"
                            aria-hidden="true"
                            src="./images/icons-fa/gauge-high_solid.svg"
                            alt="Website Icon"
                        />Speedtest</a
                    >

                    <a
                        class="button button-default"
                        href="https://code.visualstudio.com/"
                        target="_blank"
                        rel="noopener"
                        role="button"
                        ><img
                            class="icon fontawesome"
                            aria-hidden="true"
                            src="./images/icons-fa/code_solid.svg"
                            alt="Website Icon"
                        />VSCode</a
                    >

                    <h2>Others</h2>

                    <!-- Sensitive Content Module -->
                    <div
                        class="slide-container"
                        data-continue-url="https://littlelink.io"
                    >
                        <!-- Trigger Button -->
                        <a
                            class="button button-sensitive sensitive-trigger"
                            href="javascript:void(0)"
                        >
                            <img
                                class="icon"
                                aria-hidden="true"
                                src="./images/icons-extended/generic-warning.svg"
                                alt="Warning Icon"
                            />
                            Sensitive Content
                        </a>

                        <!-- The Slide-Down Panel -->
                        <div class="sensitive-panel">
                            <div class="sensitive-panel__content">
                                <p>Nothing here ;-)</p>
                                <!--
                                <p>
                                    This link may contain content that is not
                                    appropriate for all audiences.
                                </p>
                                <button
                                    class="button button-sensitive sensitive-continue"
                                >
                                    Continue
                                </button>
                            --></div>
                        </div>
                    </div>
                </div>

                <!-- Feel free to add your own footer information, including updating `privacy.html` to reflect how your LittleLink fork is set up -->
                <footer>
                    Powered by
                    <a
                        href="https://github.com/sethcottle/littlelink/"
                        target="_blank"
                        rel="noopener"
                        >LittleLink</a
                    >
                    |
                    <a
                        href="https://icp.gov.moe/?keyword=20243520"
                        target="_blank"
                        rel="noopener"
                        >萌ICP备20243520号</a
                    >
                </footer>
            </div>
        </div>

        <!-- JS -->
        <!-- <script src="./js/sensitive-content.js"></script> -->

        <!-- Custom JavaScript -->
        <script type="module" src="./js/index.js"></script>
    </body>
</html>
